export default "__VITE_PUBLIC_ASSET__c3b7a952__"